import { mayUpgradeVendorConsent } from '../consent-utils';

// GPT privacy settings for Freestar slots, from consent and the age gate.
// backendRequiresNpa is a floor that consent can't lift. Call inside googletag.cmd
// so pubads() exists.
export default function applyFreestarPrivacy(hasTargetingConsent, backendRequiresNpa) {
  if (!window.googletag?.pubads) return;

  // Under-13 viewers get the COPPA floor and never upgrade,
  // regardless of what OneTrust resolves.
  if (!mayUpgradeVendorConsent()) {
    if (window.fsprebid) {
      window.fsprebid.setConfig({ coppa: true });
    }
    window.googletag.pubads().setPrivacySettings({
      tagForAgeTreatment: 1,
      nonPersonalizedAds: true,
      restrictDataProcessing: true,
    });
    return;
  }

  const restricted = backendRequiresNpa || !hasTargetingConsent;
  window.googletag.pubads().setPrivacySettings({
    nonPersonalizedAds: restricted,
    restrictDataProcessing: restricted,
  });
}
